import { get, post } from "./index.js";

// Banner-列表
export const bannerList = param => {
  const params = {
    url: '/app-api/content/banner/list',
    query: { ...param },
  }
  return get(params)
}
// 图廊-列表
export const pictureList = param => {
  const params = {
    url: '/app-api/content/picture-recording/page',
    query: { ...param },
  }
  return get(params)
}
// 图廊-删除
export const pictureDelete = param => {
  const params = {
    url: '/app-api/content/picture-recording/delete?id='+param,
    // query: { ...param },
  }
  return post(params)
}
// 图廊-详情
export const pictureDetailList = param => {
  const params = {
    url: '/app-api/content/picture-recording/get',
    query: { ...param },
  }
  return get(params)
}
// 决定生成图片
export const genImages = param => {
  const params = {
    url: '/app-api/chatgpt/reply/genImages',
    body: { ...param },
  }
  return post(params)
}

// pc背景图片
export const pcBackground = param => {
  const params = {
    url: '/app-api/content/pc-background/page',
    query: { ...param },
  }
  return get(params)
}
// 图片转为base64
export const tobase64 = param => {
  const params = {
    url: '/app-api/content/picture-recording/base64',
    query: { ...param },
  }
  return get(params)
}
// 套餐列表
export const packageList = param => {
  const params = {
    url: '/app-api/content/package-configuration/list',
    query: { ...param },
  }
  return get(params)
}
// 用户套餐-信息
export const memberPackage = param => {
  const params = {
    url: '/app-api/content/member-package/get',
    query: { ...param },
  }
  return get(params)
}
// 图片比例
export const pictureScaleList = param => {
  const params = {
    url: '/app-api/content/picture-scale/list',
    query: { ...param },
  }
  return get(params)
}
// 单张图片删除
export const pictureUpdate = param => {
  const params = {
    url: '/app-api/content/picture-recording/update',
    body: { ...param },
  }
  return post(params)
}
// 图片下载
export const pictureDownload = param => {
  const params = {
    url: '/app-api/content/picture-recording/download',
    body: { ...param },
  }
  return post(params)
}


// WEBPACK FOOTER //
// ./src/http/home.js